// Page de connexion — même langage que l'inscription (src/styles/register.css,
// préfixe rg) : le ciel pâle, le logo, une seule carte centrée.
import { Link } from 'react-router-dom'
import LoginForm from '../components/urself/LoginForm'
import { UBrand } from '../components/urself/Logo'
import { whatsappLink } from '../lib/support'
import { useT } from '../lib/i18n'
import Seo from '../components/Seo'

const PUB = process.env.PUBLIC_URL || ''

export default function Login () {
  const t = useT()
  const l = t.login
  const wa = whatsappLink()

  return (
    <>
      {/* noindex : un formulaire de connexion n'a rien à faire dans Google. */}
      <Seo title={l.title} description={l.subtitle} path="/login" noindex />
      <div className="rg rg--login">
        <div className="rg__sky" aria-hidden="true" style={{ '--sky': `url(${PUB}/media/hero-sky.jpg)` }} />

        <header className="rg__top">
          <Link to="/" aria-label={t.nav.home}><UBrand /></Link>
          <span />
          <span className="rg__login">{l.noAccount} <Link to="/register">{l.plansLink}</Link></span>
        </header>

        <main className="lg">
          <div className="lg__card">
            <img className="lg__lock" src={`${PUB}/media/glass-lock.webp`} alt="" aria-hidden="true" width="720" height="720" />
            <h1 className="lg__h">{l.title}</h1>
            <p className="lg__sub">{l.subtitle}</p>
            <LoginForm />
          </div>

          {wa && (
            <p className="lg__help">
              {l.stuck} <a href={wa} target="_blank" rel="noopener noreferrer">{l.stuckLink}</a>
            </p>
          )}
        </main>
      </div>
    </>
  )
}
